var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_snackbar" },
    [
      _c(
        "TransitionGroup",
        { attrs: { name: "fade-05" } },
        _vm._l(_vm.rows, function(msg) {
          return _c(
            "div",
            {
              key: msg[2],
              staticClass: "_msg _ns",
              class: "bg70-" + (msg[0] || "gray")
            },
            [
              _c("div", {
                staticClass: "text",
                domProps: { innerHTML: _vm._s(_vm.format(msg[1])) }
              }),
              _c(
                "ib-button",
                {
                  staticClass: "link _close",
                  on: {
                    click: function($event) {
                      return _vm.dismiss(msg[2])
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 50 50"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M9.16 6.31L6.3 9.16 22.16 25 6.22 40.97l2.81 2.81L25 27.84l15.94 15.94 2.84-2.84L27.84 25 43.7 9.16 40.84 6.3 25 22.16z"
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }